//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  validTrademarkNum,
  onlyStr,
  isEmpty,
  validApplicant
} from "@/utils/validate";
import {isNull} from "lodash";
import {MessageBox} from "element-ui";
export default {
  layout: "menu",
  async asyncData({ query, error, $axios }) {
    try {
      const [res] = await Promise.all([$axios.get("/api/init/searchInit")]);
      const Init = res && res.data && res.data.data ? res.data.data : {};
      let arr = [];
      let nNum = Init.noticeNumber;
      for (var i = nNum; i >= 1; i--) {
        arr.push(i);
      }
      let _trademarkTP = [];
      _trademarkTP = Init.noticeTypes.map(item => {
        return { ...item, isActive: false };
      });
      return {
        searchType: query && query.type ? query.type : "1",
        searchText: query && query.text ? query.text : "",
        searchAddress: query && query.address ? query.address : "",
        searchNumber: query && query.number ? query.number : null,
        initData: Init,
        trademarkTypes: Init.trademarkTypes,
        noticeName: Init.noticeTypes[0].name, //公告类型name
        noticeNumber: arr.slice(0, 100), // 公告期号前100
        allNotice: arr,
        trademarkTP: _trademarkTP // 公告类型
      };
    } catch (err) {
      error(err);
    }
  },
  head() {
    return {
      title: "商标公告-飙局-知识产权",
      meta: [
        {
          name: "description",
          content:
            "通过商标公告期号、公告类型、商标名称、商标类别快速筛选商标公告信息，查看商标公告图片"
        },
        {
          name: "keywords",
          content:
            "商标公告,公告,商标初步审定公告,中国商标网,商标注册查询 ,商标数据库,商标查询"
        }
      ]
    };
  },
  data() {
    return {
      edition: 'highRank',
      pageHeader: 'noticeHeader',
      pageName: this.$route.query.page,
      isSearch: null, //判断是否搜索 +记录当前搜索维度 type
      crrTerm: null, //当前搜索 维度条件
      numKey: 1, // 期号刷新
      menuForm: {
        searchText: "",
        approximateSelect: "1", //近似 【更多】 下拉选项值 选项
        secondaryFiltration: "", //近似 【更多】 二次过滤关键字
        trademarkNumber: "", //商标号
        applicantJson: {
          proposer: [
            { type: 1, name: null, address: null },
            { type: 1, name: null, address: null },
            { type: 1, name: null, address: null }
          ],
          trademarkType: 1,
          trademarkName: null
        },
        agencyTexts: [{ name: "" }, { name: "" }, { name: "" }], //代理机构 list form
        proposerName: null, //申请人名称 综合查询
        proposerAddress: null, //申请人地址 综合查询
        agentName: null //代理机构 综合查询
      },

      applicantShow: false, //申请人【更多】显示隐藏
      agencyShow: false, //代理机构【更多】显示隐藏
      approShow: false, //近似自定义规则显示隐藏
      resetKey: 1, //近似 多选 刷新

      noDataMsg: "欢迎您使用",
      randomMsg: "",
      showModel: false, //弹出框
      modelKey: 1,
      modelType: 1, //1聚焦对比 2查询报告
      tableData: [], //列表数据
      searchMenuInfo: "", //群组搜索关键词
      crrKey: 1, //用于刷新类别数组
      picOrList: false, //列表模式、纯图模式
      searchCard: true, //筛选条件面板展开收起

      currentPage: 1,
      pageSize: 50,
      totalCont: 0,
      crrType: [], //当前显示群组
      legalStatusSelect: [], //法律状态多选
      trademarkTPIds: [],
      trademarkTPNames: [],
      checkAllTP: false,
      reverseTp: false,
      timeType: "1", //时间类型（申请日期，注册日期，有效日期）
      startTime: null,
      endTime: null,
      dateState: "year", //当前选择时间 状态 年月日
      noticeTypeIndex: 0, //公告类型
      isReverse: false,
      selectVal: "",
      optionsVal: "1",
      startNumber: null, //开始公告期号
      endNumber: null, //结束公告期号
      crrParameter: null,

      lOrS: true, //显示列表或者统计

      listLoading: false,
      statisticalLoading: false,
      filterLoading: false,
      historys: {
        noticeKeyword1: [],
        noticeKeyword2: [],
        noticeKeyword4: [],
        noticeKeyword5: [],
        noticeKeyword7: []
      }, //缓存搜索历史

      st_Data: {},

      m_agency: null, //申请人 弹框
      m_agencyPage: 1, //申请人 弹框
      showAgencyModel: false, //申请人 弹框
      checkedAgency: [], //申请人 弹框 多选值
      checkAllAgency: false, //申请人 弹框 多选是否已全选
      loadingAgency: false,

      tableCheckAll: false,
      listKey: 1, //手动刷新列表模式

      filterJson: {
        agentFilter: [],
        applicantFilter: [],
        classFilter: [],
        classGroupCodeFilter: [],
        codeFilter: [],
        goodsFilter: [],
        groupCodeFilter: [],
        statusFilter: [],
        tradeFlowFilter: [],
        trademarkFilter: []
      },
      filterWhere: {
        trademarkName: [], //商标名称1
        classId: [],
        code: [],
        statusId: [],
        proposerInfo: [],
        groupCode: [],
        goods: [],
        allClassGroupCode: [],
        flowName: [],
        agentName: [],
        applyDate: [],
        registerDate: [],
        trademarkIds: [],
        searchAgentId: []
      },
      sortApply: null,
      sortRegister: null,
      crrOrderName: null,
      crrSortName: null,
      tabSels: [], //列表选中值
      modelList: [], //弹框列表数据
      modelcheckNum: 0, //弹框选中数量
      listcheckNum: 0, //列表选中数量
      crrClassGroup: {
        types: [],
        groups: []
      }, //当前搜索选择的类别群组

      // sMenus: [
      //   { name: "类别及群组覆盖统计", checked: true, disabled: false },
      //   { name: "时间趋势", checked: true, disabled: false },
      //   { name: "申请人统计", checked: true, disabled: false },
      //   { name: "法律状态", checked: true, disabled: false },
      //   { name: "商标类型", checked: false, disabled: true },
      //   { name: "代理机构统计", checked: true, disabled: false }
      // ],
      noDateHeight: "0px",
      isMounted: false,
      isDisableBtn: false, // 防止重复提交
      temporary: {}, // 临时字段,防止污染原字段
      parmeJson: {
        searchType: "",
        keyword: null,
        menu: null, //近似 menu选项
        select: null, //近似 下拉
        selectKeyword: null, //二次过滤关键词
        code: null, //商标号
        proposerInfo: null,
        agentInfo: null,
        proposerName: null, //申请人名称  综合查询
        proposerAddress: null, //申请人地址  综合查询
        agentName: null, //代理机构 综合查询

        classIds: null, //类别 --加s

        page: null,
        num: null,
        timeType: null, //时间类型（申请日期，注册日期，有效日期）
        startTime: null, //开始时间
        endTime: null, //结束时间
        startNumber: null, //开始公告期号
        endNumber: null, //结束公告期号
        statusIds: null, //法律状态
        flows: null, //商标流程（申请中，已注册）
        appType: 0, //公告类型  商标公告传0

        filterWhere: null,
        order: null,
        sort: null,
        noticeTypes: null // 公告类型
      },
      numberForm: {
        numberChecks: [],
        noticeRadio: true,
        typeChecks: [],
        allType: true
      }
    };
  },
  created() {
    // const text = this.$route.query.text;
    // const type = this.$route.query.type;
    // if (type == "3" || type == 3) {
    //   this.menuForm.trademarkNumber = text;
    // } else {
    //   this.menuForm.searchText = text ? text : "";
    // }

    // if (this.menuForm.searchText || this.menuForm.trademarkNumber) {
    //   if (this.searchAddress) {
    //     this.applicantShow = true;
    //     this.menuForm.applicantJson.proposer[0].name = this.menuForm.searchText;
    //     this.menuForm.applicantJson.proposer[0].address = this.searchAddress;
    //   }
    //   this.searchSubmit();
    // }

    /*this.$axios.post('/api/ajax/auth', {reqUrl: 'api/notice/search'}).then(res => {
      let mag = res.data.msg ? res.data.msg : '账号已过期，请联系售前人员'
      MessageBox.confirm(mag, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        type: 'warning'
      }).then(()=> {
        console.log('跳转')
      })
    })*/

    if (this.searchNumber) {
      this.numberForm.noticeRadio = false;
      this.numberForm.numberChecks = [parseInt(this.searchNumber)];
    }
    this.numberCount();
    this.typeCount();

    var str = this.getRandomMsg();
    this.randomMsg = str;
  },
  destroyed() {
    document.removeEventListener("keydown", this.keyFanHandler);
  },
  mounted() {
    this.parameterIntegration();
    this.temporary = JSON.parse(JSON.stringify(this.parmeJson));
    //读取搜索历史
    this.historys = {
      noticeKeyword1: this.$cookies.get("noticeKeyword1"),
      noticeKeyword2: this.$cookies.get("noticeKeyword2"),
      noticeKeyword4: this.$cookies.get("noticeKeyword4"),
      noticeKeyword5: this.$cookies.get("noticeKeyword5"),
      noticeKeyword7: this.$cookies.get("noticeKeyword7")
    };

    // 滚动固定表头
    let dom = document.getElementById("RightPlan");
    dom.onscroll = e => {
      this.scrollFun(dom);
    };

    //无数据图片高度
    this.noDateHeight = document.documentElement.clientHeight - 520 + "px"; //

    this.keyFun();
    this.isMounted = true;
    this.getLocalCheck();
    this.trademarkSearch();
  },
  computed: {
    modelScrollDisabled() {
      return (
        this.loadingAgency ||
        (this.m_agency && this.m_agency.rows.length >= this.m_agency.total)
      );
    }
  },
  methods: {
    scrollFun(dom) {
      let nodeList = document.querySelectorAll(".j-scroll-left");
      let left = -dom.scrollLeft + "px";
      let isHide = dom.scrollTop > (this.searchCard ? 535 : 165);
      let menu = this.$store.state.isHideMenu;
      nodeList.forEach(item => {
        item.style.left = left;
        if (isHide) {
          item.classList.add("fixed-head");
        } else {
          item.classList.remove("fixed-head");
        }
      });

      if (nodeList.length == 2) {
        nodeList[0].style.paddingLeft = !isHide || menu ? "0" : "166px";
        nodeList[1].style.paddingLeft = !isHide || menu ? "20px" : "186px";
      }

      let hideList = document.querySelectorAll(".j-scroll-hide");
      let showList = document.querySelectorAll(".j-scroll-show");

      hideList.forEach(item => {
        item.style.display = isHide ? "block" : "none";
      });
      showList.forEach(item => {
        item.style.display = isHide ? "none" : "block";
      });
    },
    keyFanHandler(e) {
      if (e.target.nodeName === "INPUT" || e.target.nodeName === "TEXTAREA") {
        return;
      }
      // 总页码
      let pageTo = (this.totalCont + this.pageSize - 1) / this.pageSize;

      if (e.code === "ArrowLeft" && this.currentPage > 1) {
        this.$refs.pagination.prev();
      } else if (e.code === "ArrowRight" && this.currentPage < pageTo) {
        this.$refs.pagination.next();
      }
    },
    keyFun() {
      document.addEventListener("keydown", this.keyFanHandler);
    },
    changePickDate(name) {
      if (this.dateState == "year") {
        this.dateState = "month";
        this.showDate(name);
      } else if (this.dateState == "month") {
        this.dateState = "date";
        this.showDate(name);
      } else if (this.dateState == "date") {
        this.dateState = "year";
      }
    },
    showDate(name) {
      setTimeout(() => {
        this.$refs[name].$refs.reference.$refs.input.focus();
      }, 100);
    },
    numberCount() {
      let nums = [];
      if (this.numberForm.noticeRadio) {
        nums = nums.concat(this.noticeNumber.slice(0, 12));
      }

      if (this.numberForm.numberChecks.length) {
        nums = nums.concat(this.numberForm.numberChecks);
      }

      // if (this.searchNumber) {
      //   let sn = [parseInt(this.searchNumber)];
      //   nums = nums.concat(sn);
      // }

      return this.unique(nums);
    },
    //数组去重复
    unique(arr) {
      var result = [],
        hash = {};
      for (var i = 0, elem; (elem = arr[i]) != null; i++) {
        if (!hash[elem]) {
          result.push(elem);
          hash[elem] = true;
        }
      }
      return result;
    },
    typeCount() {
      let nums = [];
      if (this.numberForm.allType) {
        nums = this.trademarkTP.map(item => item.id);
      } else {
        nums = this.numberForm.typeChecks;
      }
      return nums;
    },
    // 参数整合
    parameterIntegration() {
      this.parmeJson = {
        searchType: this.searchType,
        keyword: null,
        menu: null, //近似 menu选项
        select: null, //近似 下拉
        selectKeyword: null, //二次过滤关键词
        code: null, //商标号
        proposerInfo: null,
        agentInfo: null,
        proposerName: null, //申请人名称  综合查询
        proposerAddress: null, //申请人地址  综合查询
        agentName: null, //代理机构 综合查询

        classIds: this.selectedCount().types, //类别 --加s

        page: this.currentPage,
        num: this.pageSize,
        timeType: this.timeType, //时间类型（申请日期，注册日期，有效日期）
        startTime: this.startTime, //开始时间
        endTime: this.endTime, //结束时间
        startNumber: this.startNumber, //开始公告期号
        endNumber: this.endNumber, //结束公告期号
        statusIds: this.legalStatusSelect, //法律状态
        flows: this.trademarkTPIds, //商标流程（申请中，已注册）
        appType: 0, //公告类型  商标公告传0

        filterWhere: this.filterWhere,
        order: this.crrOrderName,
        sort: this.crrSortName,
        noticeNumbers: this.numberCount(), // 公告期号
        noticeTypes: this.typeCount() // 公告类型
      };

      this.crrClassGroup = this.selectedCount();

      if (this.searchType == "1") {
        if (this.approShow) {
          var menu = [];
          if (this.initData && this.initData.approximate) {
            this.initData.approximate.menu.forEach(item => {
              if (item.isActive) {
                menu.push(item.id);
              }
            });
          }
          this.parmeJson.menu = menu.join(","); //近似 menu选项
          this.parmeJson.keyword = this.menuForm.searchText;
          this.parmeJson.select = this.menuForm.approximateSelect; //近似 下拉
          this.parmeJson.selectKeyword = this.menuForm.secondaryFiltration; //二次过滤关键词
        } else {
          this.parmeJson.keyword = this.menuForm.searchText;
        }
      } else if (this.searchType == "2") {
        this.parmeJson.keyword = this.menuForm.searchText;
      } else if (this.searchType == "3") {
        this.parmeJson.code = this.menuForm.trademarkNumber;
      } else if (this.searchType == "4") {
        if (this.applicantShow) {
          this.parmeJson.proposerInfo = this.menuForm.applicantJson;
        } else {
          this.parmeJson.keyword = this.menuForm.searchText;
        }
      } else if (this.searchType == "5") {
        if (this.agencyShow) {
          this.parmeJson.agentInfo = this.menuForm.agencyTexts;
        } else {
          this.parmeJson.keyword = this.menuForm.searchText;
        }
      } else if (this.searchType == "6") {
        this.parmeJson.keyword = this.menuForm.searchText;
        this.parmeJson.proposerName = this.menuForm.proposerName; //申请人名称  综合查询
        this.parmeJson.proposerAddress = this.menuForm.proposerAddress; //申请人地址  综合查询
        this.parmeJson.agentName = this.menuForm.agentName; //代理机构 综合查询
      }
      this.crrParameter = this.parmeJson;
      //return pams;
    },
    //过滤参数 校验
    searchSubmit(str) {
      this.isDisableBtn = true;
      setTimeout(() => {
        this.isDisableBtn = false;
      }, 2000); // 避免重复提交
      if (this.listLoading) {
        return;
      }

      if (!this.numberCount().length && this.searchType =="1") {
        this.$message("近似查询时，公告期号不能为空！");
        return;
      }
      if (this.searchType == "1") {
        if (
          validApplicant(this.menuForm.searchText) ||
          onlyStr(this.menuForm.searchText)
        ) {
          this.$message("目前搜索仅支持输入纯英文、纯数字或纯汉字");
          return;
        }
        if (onlyStr(this.menuForm.secondaryFiltration)) {
          this.$message("二次过滤关键字仅支持输入纯英文、纯数字或纯汉字");
          return;
        }
        if (this.menuForm.searchText.length > 50) {
          return this.$message("商标名称不能多余50个字");
        }
      } else if (this.searchType == "2") {
        if (this.menuForm.searchText.length > 50) {
          return this.$message("商标名称不能多余50个字");
        }
      } else if (this.searchType == "3") {
        if (!isEmpty(this.menuForm.trademarkNumber)) {

          //识别商标号为字符串
          let tmNumArr = this.menuForm.trademarkNumber.match(/\d+[a-z|A-Z]|[a-z|A-Z]?\d+/g);
          if (!isNull(tmNumArr)) {
            this.menuForm.trademarkNumber = tmNumArr.toString();
            if (tmNumArr.length > 500) {
              return this.$confirm(
                "超过最大500查询量，仅展示前500个商标号结果",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消"
                }
              )
                .then(() => {
                  this.searchInfo();

                })
                .catch(() => { });
            }
          } else {
            return this.$message(
              "请输入正确的商标号格式，支持空格或逗号隔开，支持从文字中自动识别"
            );
          }
        } else {
          return this.$message("请输入商标号进行搜索！");
        }
      } else if (this.searchType == "4") {
        if (this.applicantShow) {
          const proJson = this.menuForm.applicantJson.proposer;
          if (
            (!isEmpty(proJson[0].name) && proJson[0].name.length > 50) ||
            (!isEmpty(proJson[1].name) && proJson[1].name.length > 50) ||
            (!isEmpty(proJson[2].name) && proJson[2].name.length > 50)
          ) {
            return this.$message("申请人名称不能多余50个字");
          }

          if (
            validApplicant(proJson[0].name) ||
            validApplicant(proJson[1].name) ||
            validApplicant(proJson[2].name)
          ) {
            return this.$message("不能输入特殊符号");
          }

          if (
            (!isEmpty(proJson[0].address) && isEmpty(proJson[0].name)) ||
            (!isEmpty(proJson[1].address) && isEmpty(proJson[1].name)) ||
            (!isEmpty(proJson[2].address) && isEmpty(proJson[2].name))
          ) {
            return this.$message("请输入对应的申请人名称");
          }
        } else {
          if (validApplicant(this.menuForm.searchText)) {
            return this.$message("不能输入特殊符号");
          }
          if (this.menuForm.searchText.length > 50) {
            return this.$message("申请人名称不能多余50个字");
          }
        }
      } else if (this.searchType == "5") {
        //代理机构 弹框
        if (this.agencyShow) {
          if (
            isEmpty(this.menuForm.agencyTexts[0].name) &&
            isEmpty(this.menuForm.agencyTexts[1].name) &&
            isEmpty(this.menuForm.agencyTexts[2].name)
          ) {
            return this.searchInfo();
          }
          if (
            (!isEmpty(this.menuForm.agencyTexts[0].name) &&
              validApplicant(this.menuForm.agencyTexts[0].name)) ||
            (!isEmpty(this.menuForm.agencyTexts[1].name) &&
              validApplicant(this.menuForm.agencyTexts[1].name)) ||
            (!isEmpty(this.menuForm.agencyTexts[2].name) &&
              validApplicant(this.menuForm.agencyTexts[2].name))
          ) {
            return this.$message("不能输入特殊符号");
          }

          if (
            this.menuForm.agencyTexts[0].name.length > 50 ||
            this.menuForm.agencyTexts[1].name.length > 50 ||
            this.menuForm.agencyTexts[2].name.length > 50
          ) {
            return this.$message("代理机构名称不能多余50个字！");
          }
        } else {
          if (isEmpty(this.menuForm.searchText)) {
            return this.searchInfo();
          }
          if (
            !isEmpty(this.menuForm.searchText) &&
            validApplicant(this.menuForm.searchText)
          ) {
            return this.$message("不能输入特殊符号");
          }

          if (this.menuForm.searchText.length > 50) {
            return this.$message("代理机构名称不能多余50个字");
          }
        }
        this.showAgencyModel = true;
        this.scrollRefreshAgency();
        return;
      } else if (this.searchType == "6") {
      }
      this.parameterIntegration();
      this.searchInfo();
    },
    //区域 敏感词 提示
    searchInfo() {
      if (this.searchType == "1") {
        this.$refs.approximateCheck.getList();
        /*this.$axios
          .post("/api/Ajax/check", { keyword: this.menuForm.searchText })
          .then(res => {
            if (res.data.data) {
              var resData = res.data.data;
              if (resData.sensitive) {
                //包含的非区域敏感词
                const h = this.$createElement;
                var arr = this.menuForm.searchText.split(resData.sensitive);
                let msg = h("p", null, [
                  h("span", null, "禁用敏感词："),
                  h("span", null, arr[0]),
                  h("span", { style: "color: #fda14d" }, resData.sensitive),
                  h("span", null, arr[1])
                ]);
                this.openMessge(msg);
              } else if (resData.area) {
                //包含的区域名称
                const h = this.$createElement;
                var arr = this.menuForm.searchText.split(resData.area);
                let msg = h("p", null, [
                  h("span", null, "禁用县级以上行政区划名称："),
                  h("span", null, arr[0]),
                  h("span", { style: "color: #fda14d" }, resData.area),
                  h("span", null, arr[1])
                ]);
                this.openMessge(msg);
              } else {
                this.trademarkSearch();
              }
            } else {
              this.$message(res.data.msg);
            }
          });*/
      }
      this.trademarkSearch();
    },
    openMessge(msg) {
      this.$msgbox({
        title: "提示",
        message: msg,
        type: "warning",
        showCancelButton: false,
        confirmButtonText: "确定"
      }).then(() => {
        this.trademarkSearch();
      });
    },
    //读取localStorage的已选
    getLocalCheck() {
      if (this.isMounted) {
        let his = localStorage ? localStorage.getItem("noticeListCheck") : [];
        his = his ? JSON.parse(his) : [];
        this.tabSels = his;
        this.listcheckNum = his.length;
        for (let i = 0, len = this.tableData.length; i < len; i++) {
          for (let j = 0, len = his.length; j < len; j++) {
            if (this.tableData[i].id == his[j].id) {
              this.tableData[i].checked = true;
            }
          }
        }
        this.listKey++;
      }
    },
    /**
     * 商标查询 列表 统计 表头筛选选项
     * @param isFilter 默认不传和 false：请求过滤接口 true:不请求
     * @param isStatis 统计 true:不请求
     * @param resetPam false 重置数据
     * @param resetPam false 重置数据
     * @param pam 自定义请求参数
     * @param isAgency 代理机构弹框确认不清除代理机构参数
     * @param isFilterSort 不清除排序筛选参数
     */
    trademarkSearch(isFilter, isStatis, resetPam, pam, isAgency, isFilterSort) {
      this.listLoading = true;

      if (!resetPam) {
        //是否重置数据
        this.resetRes(isAgency, isStatis, isFilterSort);
      }
      this.tableData = [];
      this.parameterIntegration();
      this.$axios
        .post("/api/notice/search", pam ? pam : this.parmeJson)
        .then(res => {
          if (res && res.data && res.data.code == -9997) {
            this.showAgencyModel = false;
            this.listLoading = false;
            return this.$message(res.data.msg);
          }
          var dataInfo = res.data.data;
          if (dataInfo) {
            this.totalCont = dataInfo.total ? dataInfo.total : 0;
            this.tableCheckAll = false;
            let rowList = dataInfo.rows;
            if (rowList) {
              this.tableData = rowList;
              this.getLocalCheck();
            }
          }

          this.noDataMsg = "无搜索结果";
          this.isSearch = this.searchType;
          this.crrTerm = this.countTerm().str;
          let str = this.getRandomMsg();
          this.randomMsg = str;
          this.listLoading = false;
          this.setKeyCookies();
        });
    },
    //表头筛选 列表查询
    getSearchFilter(pam, nameText) {
      this.filterLoading = true;
      var pams = this.parmeJson;
      pams.headerFilter = pam;
      pams.page = 1;
      let agentId = this.filterWhere.searchAgentId;
      if (nameText) {
        pams.filterWhere = {
          trademarkLikeName: nameText
        };
      } else if (agentId) {
        pams.filterWhere = {
          searchAgentId: agentId
        };
      } else {
        pams.filterWhere = null;
      }
      this.$axios.post("/api/notice/searchFilter", pams).then(res => {
        let crrJson = res.data.data;
        this.filterJson[pam] = crrJson[pam];
        this.filterLoading = false;
      });
    },
    // 近似 选择
    checkApproximateMenu(item, index) {
      item.isActive = !item.isActive;
      this.initData.approximate.menu.splice(index, 1, item);
    },
    //近似 子规则 全选 反选
    approximateMenuReset(type) {
      if (this.initData && this.initData.approximate) {
        let not = this.initData.approximate.menu.filter(ft => !ft.isActive);
        this.initData.approximate.menu.forEach(item => {
          if (type == 1) {
            item.isActive = false;
          } else if (type == 2) {
            item.isActive = not.length > 0;
          } else {
            item.isActive = !item.isActive;
          }
        });
        this.resetKey++;
      }
    },
    getRandomMsg() {
      return "点击方向键 ← → 实现公告快速翻页";
    },
    //点击选中类别
    clickType(index, item) {
      this.crrType = item.children;
      if (!item.isActive) {
        item.isActive = true;
        this.trademarkTypes.splice(index, 1, item);
      }
    },
    //删除类别
    delCrrType(index, item) {
      for (let i = 0, len = item.children.length; i < len; i++) {
        item.children[i].isActive = false;
      }
      this.crrType = [];
      item.isActive = false;
      this.trademarkTypes.splice(index, 1, item);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.trademarkSearch(true, true, true);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.trademarkSearch(true, true, true);
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    goDetails(item) {
      window.open(
        this.tools.tmDetailUrl(item.trademarkIdKey, this.searchType),
        "_blank"
      );
    },
    // type  1聚焦对比 2查询报告
    clickButton(type) {
      this.modelList = JSON.parse(JSON.stringify(this.tabSels));
      this.modelcheckNum = this.tabSels.length;
      this.showModel = true;
      this.modelType = type;
    },
    // 导出Excel
    listExport(checkList) {
      const arr = this.tabSels.map(item => item.id);
      var pam = this.parmeJson;
      this.filterWhere.trademarkIds = arr;
      pam.filterWhere = this.filterWhere;
      pam.entrancePage = 'notice';
      pam.exportKey = this.pageHeader;
      pam.exportFields = checkList.join(',')
      this.$axios.post("/api/notice/listExport", pam).then(res => {
        console.log(res);
      });
    },
    //点击弹框的确认 1 聚焦对比 2 导出Excel报告 3 在线传阅报告
    confirmModel(type) {
      if (!this.isSearch && type != 1) {
        //未查询
        return this.$message({
          showClose: true,
          message: "请先进行商标查询",
          type: "error"
        });
      }
      let count = this.contModelSel();
      if (type == 1) {
        if (count.idsArr.length <= 50) {
          if (count.idsArr.length) {
            window.open("/contrast/" + count.idsArr.join(","), "_blank");
          } else {
            window.open("/contrast", "_blank");
          }
        } else {
          this.$message({
            showClose: true,
            message: "商标对比不能超过50个~",
            type: "error"
          });
        }
      } else {
        if (count.idsArr.length <= 20) {
          const pams = {
            tmData: count.pamArr,
            keyword: this.menuForm.searchText
          };

          if (type == 3) {
            localStorage.setItem("queryReportParams", JSON.stringify(pams));
            window.open("/queryReport", "_blank");
          } else if (type == 2) {
            this.$axios.post("/api/Queryreport/export", pams).then(res => {
              this.$message(res.data.msg);
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: "支持20个及以内的商标查询报告的生成~",
            type: "error"
          });
        }
        window.sendEventCall(null, "noNum");
      }
    },

    historyGo(item) {
      this.menuForm.searchText = item;
      //this.searchSubmit();
    },
    //类别群组反选重置 type:false 反选    type:true 重置
    rAdnSI(name, type) {
      // 反选/重置  type:false 反选   type:true 重置
      if (name === "all") {
        this.resetNotice(type);
      } else {
        if (name == "trademarkTypes") {
          // 类别
          this[name].forEach(item => {
            item.isActive = type ? false : !item.isActive;
          });
          this.crrKey++;
        } else if (name == "numberChecks") {
          this.numberForm[name] = [];
          this.searchNumber = null;
          this.numberForm.noticeRadio = false;
        } else if (name == "typeChecks") {
          this.numberForm[name] = [];
          this.numberForm.allType = false;
        }
      }
    },
    resetNotice(type) {
      // 全部重置
      this.trademarkTypes.forEach(item => {
        item.isActive = type ? false : !item.isActive;
      });

      this.numberForm.typeChecks = [];
      this.numberForm.allType = false;
      this.numberForm.numberChecks = [];
      this.numberForm.noticeRadio = false;

      this.crrKey++;
    },
    //全选类别
    selectAllClass() {
      this.crrKey += 1;
      if (this.trademarkTypes) {
        let not = this.trademarkTypes.filter(item => !item.isActive);
        this.trademarkTypes.forEach(item => {
          item.isActive = not.length > 0;
        });
      }
    },
    // 输入群组号名称搜索
    searchMenuType() {
      if (this.crrType) {
        this.crrType.forEach(item => {
          if (
            !this.searchMenuInfo ||
            item.label.indexOf(this.searchMenuInfo) > -1
          ) {
            item.show = false;
          } else {
            item.show = true;
          }
        });
      }
    },
    selectedCount() {
      //类别统计
      var types = [];
      if (this.trademarkTypes) {
        for (let i = 0, len = this.trademarkTypes.length; i < len; i++) {
          if (this.trademarkTypes[i].isActive) {
            types.push(this.trademarkTypes[i].value);
          }
        }
      }
      return { types: types, groups: [] };
    },
    //型关键字等统计
    countTerm() {
      let index = parseInt(this.searchType) - 1;
      if (!this.tools.searchMenus) {
        return;
      }
      let satrt = this.tools.searchMenus[index].name + "：";
      let str = "";
      if (this.searchType == "1") {
        str = this.menuForm.searchText;
        if (this.approShow) {
          var menus = [];
          this.initData.approximate.menu.forEach(element => {
            if (element.isActive) {
              menus.push(element.name);
            }
          });
          if (menus.length) {
            str = this.menuForm.searchText + "（" + menus.join(",") + "）";
          }
          if (this.menuForm.secondaryFiltration) {
            this.initData.approximate.select.forEach(element => {
              if (this.menuForm.approximateSelect == element.id) {
                str += "且" + element.name + this.menuForm.secondaryFiltration;
              }
            });
          }
        }
      } else if (this.searchType == "3") {
        str += this.menuForm.trademarkNumber;
      } else if (this.searchType == "4") {
        if (this.applicantShow) {
          var menus = [];

          this.menuForm.applicantJson.proposer.forEach(element => {
            if (element.name) {
              str +=
                "[" +
                (element.type == 1 ? "中文（" : "英文：（") +
                "名称：" +
                element.name;
              if (element.address) {
                str += "，地址：" + element.address;
              }
              str += "）]";
            }
          });
          if (this.menuForm.applicantJson.trademarkName) {
            str +=
              " - " +
              (this.menuForm.applicantJson.trademarkType == 1
                ? "精准匹配:"
                : "模糊匹配:") +
              this.menuForm.applicantJson.trademarkName;
          }
        } else {
          str += this.menuForm.searchText;
        }
      } else if (this.searchType == "5") {
        if (this.agencyShow) {
          var arr = [];
          this.menuForm.agencyTexts.forEach(element => {
            if (element.name) {
              arr.push(element.name);
            }
          });
          str += arr.join(",");
        } else {
          str += this.menuForm.searchText;
        }
      } else if (this.searchType == "6") {
        if (this.menuForm.searchText) {
          str += " 商标名称：" + this.menuForm.searchText;
        }
        if (this.menuForm.proposerName) {
          str += " 申请人名称：" + this.menuForm.proposerName;
        }
        if (this.menuForm.proposerAddress) {
          str += " 申请人地址：" + this.menuForm.proposerAddress;
        }
        if (this.menuForm.agentName) {
          str += " 代理机构：" + this.menuForm.agentName;
        }
      } else {
        str += this.menuForm.searchText;
      }
      return {
        info: str ? satrt + str : null,
        str: str
      };
    },
    //表单统计
    countForm() {
      let resStr = "";
      let isData = false;
      if (this.legalStatusSelect && this.legalStatusSelect.length) {
        let statusId = "";
        this.legalStatusSelect.forEach(element => {
          if (element == "1") {
            statusId += "申请中 ";
          } else if (element == "2") {
            statusId += "已注册 ";
          } else if (element == "3") {
            statusId += "已无效 ";
          }
        });
        resStr += " " + "法律状态：" + statusId;
        isData = true;
      }
      if (this.trademarkTPIds.length) {
        resStr += " " + "商标流程：" + this.trademarkTPNames.join(",");
        isData = true;
      }
      if (this.startTime && this.endTime) {
        this.initData.selectDate.forEach(element => {
          if (element.id == this.timeType) {
            resStr +=
              " " + element.name + "：" + this.startTime + "至" + this.endTime;
          }
        });
        isData = true;
      }

      if (this.startNumber && this.endNumber) {
        resStr +=
          " " +
          this.initData.noticeTypes[this.noticeTypeIndex].name +
          "：" +
          this.startNumber +
          "至" +
          this.endNumber +
          "期";
        isData = true;
      }

      return {
        str: resStr,
        isData: isData
      };
    },
    //计算已选name值 用于当前搜索条件展示
    changeTrademarkTP(val) {
      this.trademarkTPNames = []; //初始化数据
      for (let i = 0; i <= val.length; i++) {
        this.initData.trademarkTP.find(item => {
          if (item.id == val[i]) {
            this.trademarkTPNames.push(item.name);
          }
        });
      }
    },
    handleCheckAllTP(type) {
      let arr = this.initData.trademarkTP;
      let name = [],
        ids = [];
      for (let i = 0, len = arr.length; i < len; i++) {
        if (type) {
          name.push(arr[i].name);
          ids.push(arr[i].id);
        } else {
          if (this.trademarkTPIds.indexOf(arr[i].id) == -1) {
            name.push(arr[i].name);
            ids.push(arr[i].id);
          }
        }
      }
      this.checkAllTP = type;
      this.trademarkTPNames = name;
      this.trademarkTPIds = ids;
    },
    resetForm() {
      this.legalStatusSelect = [];
      this.trademarkTPIds = [];
      this.trademarkTPNames = [];
      this.timeType = "1";
      this.startTime = null;
      this.endTime = null;
      this.noticeTypeIndex = 0;
      this.startNumber = null;
      this.endNumber = null;
    },
    //重置关键字等
    resetType() {
      this.approximateMenuReset(1); //近似 menus
      this.menuForm = {
        searchText: "",
        approximateSelect: "1", //近似 【更多】 下拉选项值 选项
        secondaryFiltration: "", //近似 【更多】 二次过滤关键字
        trademarkNumber: "", //商标号
        applicantJson: {
          proposer: [
            { type: 1, name: null, address: null },
            { type: 1, name: null, address: null },
            { type: 1, name: null, address: null }
          ],
          trademarkType: 1,
          trademarkName: null
        },
        agencyTexts: [{ name: "" }, { name: "" }, { name: "" }], //代理机构 list form
        proposerName: null, //申请人名称 综合查询
        proposerAddress: null, //申请人地址 综合查询
        agentName: null //代理机构 综合查询
      };
    },
    // 菜单 面板 隐藏显示  type 1 近似 2 申请人 3 代理机构
    SHMenuPlan(type, isShow) {
      if (isShow) {
        if (type == 1) {
          this.approShow = true;
        } else if (type == 2) {
          this.applicantShow = true;
          this.menuForm.applicantJson.proposer[0].name = this.menuForm.searchText;
        } else if (type == 3) {
          this.agencyShow = true;
          this.menuForm.agencyTexts[0].name = this.menuForm.searchText;
        }
      } else {
        if (type == 1) {
          this.approShow = false;
        } else if (type == 2) {
          for (var i = 0; i < 3; i++) {
            if (this.menuForm.applicantJson.proposer[i].name) {
              this.menuForm.searchText = this.menuForm.applicantJson.proposer[
                i
              ].name;
              break;
            }
          }
          this.menuForm.applicantJson = {
            proposer: [
              { type: 1, name: null, address: null },
              { type: 1, name: null, address: null },
              { type: 1, name: null, address: null }
            ],
            trademarkType: 1,
            trademarkName: null
          };
          this.applicantShow = false;
        } else if (type == 3) {
          for (var i = 0; i < 3; i++) {
            if (this.menuForm.agencyTexts[i].name) {
              this.menuForm.searchText = this.menuForm.agencyTexts[i].name;
              break;
            }
          }
          this.menuForm.agencyTexts = [
            { name: "" },
            { name: "" },
            { name: "" }
          ];
          this.agencyShow = false;
        }
      }
    },
    closeAgency() {
      this.m_agencyPage = 1;
      this.m_agency = null;
    },
    //弹框中滚动加载代理机构
    scrollRefreshAgency() {
      this.parameterIntegration();
      var pam = this.parmeJson;
      pam.page = this.m_agencyPage;
      this.loadingAgency = true;
      this.$axios.post("/api/ajax/agentSearch", pam).then(res => {
        console.log(res);
        if (res && res.data && res.data.code == -9997) {
          this.showAgencyModel = false;
          this.loadingAgency = false;
          return this.$message(res.data.msg);
        }
        if (res && res.data && res.data.data) {
          let resData = res.data.data;
          if (resData.total == 1) {
            this.okAgency([resData.rows[0].id]); //只有一条数据直接查询
          }
          if (this.m_agencyPage == 1) {
            this.m_agency = resData;
          } else {
            this.m_agency.rows = this.m_agency.rows.concat(resData.rows);
          }

          if (resData.total > this.m_agency.rows.length) {
            this.m_agencyPage++;
          }
        } else {
          this.$message(resData.msg);
        }
        this.loadingAgency = false;
      });
    },
    //代理机构查询弹框-点击确认
    okAgency(pam) {
      if (pam) {
        this.filterWhere.searchAgentId = pam;
      } else {
        if (this.m_agency && this.m_agency.rows.length) {
          const arr = this.m_agency.rows
            .filter(row => row.checked)
            .map(item => item.id);
          if (arr.length) {
            this.filterWhere.searchAgentId = arr;
          } else {
            return this.$message("请选择需要查询的代理机构");
          }
        } else {
          return (this.showAgencyModel = false);
        }
      }
      this.showAgencyModel = false;
      this.trademarkSearch(false, false, false, false, true);
    },
    // 代理机构查询弹框-点击全选
    allChangeAgency() {
      if (this.m_agency) {
        this.m_agency.rows.map(item => {
          item.checked = this.checkAllAgency;
        });
      }
    },
    agencyCheck(item, index) {
      item.checked = !item.checked;
      this.m_agency.rows.splice(index, 1, item);
    },
    //表头过滤- 弹框-点击确定
    filterConfirm() {
      this.trademarkSearch(true, false, false, false, false, true);
    },
    //表头排序
    filterListSort(order, sort) {
      this.crrOrderName = order;
      this.crrSortName = sort;
      this.trademarkSearch(true, true, false, false, false, true);
    },
    //弹框删除按钮
    modelDel(item, index) {
      console.log(item.checkTwo);
      if (!item.checkTwo) {
        //false 为选中 所以 false 不减1
        this.modelcheckNum--;
      }

      this.modelList.splice(index, 1);
    },
    //选中  存入缓存
    checkList(item, index) {
      let his = localStorage.getItem("noticeListCheck");
      let list = his ? JSON.parse(his) : [];
      if (!item.checked) {
        item.crrCondition = this.crrClassGroup.types.join(",");
        // item.crrGroupCode = this.crrClassGroup.groups.join(",");
        list.push(item);
      } else {
        for (let i = 0, len = list.length; i < len; i++) {
          if (list[i] && list[i].id == item.id) {
            list.splice(i, 1);
          }
        }
      }
      item.checked = !item.checked;
      this.tableData.splice(index, 1, item);
      this.tabSels = list;
      this.listcheckNum = list.length;
      localStorage.setItem("noticeListCheck", JSON.stringify(list));
    },
    //清除选中 和缓存
    cleanAll() {
      this.tabSels = [];
      this.listcheckNum = 0;
      if (this.tableData) {
        this.tableData.forEach(item => {
          item.checked = false;
        });
      }
      this.tableCheckAll = false;
      this.listKey++;
      if (localStorage) {
        localStorage.setItem("noticeListCheck", "");
      }
    },
    //全选 存入缓存
    tableCheckAllChange() {
      let his = localStorage.getItem("noticeListCheck");
      let checks = his ? JSON.parse(his) : [];
      let tab = this.tableData;
      let newArr = [];
      for (let j = 0, len = tab.length; j < len; j++) {
        if (!this.tableCheckAll) {
          //全选  push 未选中的
          if (!tab[j].checked) {
            tab[j].crrCondition = this.crrClassGroup.types.join(",");
            // tab[j].crrGroupCode = this.crrClassGroup.groups.join(",");
            checks.push(tab[j]);
          }
        } else {
          //清空当前页  删除选中的
          if (tab[j].checked) {
            for (let i = 0, len = checks.length; i < len; i++) {
              if (checks[i] && checks[i].id == tab[j].id) {
                checks.splice(i, 1);
              }
            }
          }
        }
        tab[j].checked = !this.tableCheckAll;
        newArr.push(tab[j]);
      }
      this.tableData = newArr;
      this.tabSels = checks;
      this.listcheckNum = checks.length;
      this.tableCheckAll = !this.tableCheckAll;
      localStorage.setItem("noticeListCheck", JSON.stringify(checks));
    },
    // 弹框二次选择
    clickCheckTwo(item, index) {
      if (this.modelType != 2) {
        item.checkTwo = !item.checkTwo;
        if (item.checkTwo) {
          this.modelcheckNum--;
        } else {
          this.modelcheckNum++;
        }
        this.modelList.splice(index, 1, item);
      }
    },
    contModelSel() {
      var arr = [];
      var pams = [];
      if (this.modelList) {
        for (let i = 0, len = this.modelList.length; i < len; i++) {
          if (!this.modelList[i].checkTwo) {
            const info = this.modelList[i];
            arr.push(info.trademarkId);
            pams.push({
              tid: info.id,
              weight: info.weight,
              classId: info.crrCondition,
              groupCode: info.crrGroupCode
            });
          }
        }
      }
      if (!pams.length) {
        pams = [
          {
            tid: null,
            weight: null,
            classId: this.crrClassGroup.types.join(",")
            // groupCode: this.crrClassGroup.groups.join(",")
          }
        ];
      }
      return {
        idsArr: arr,
        pamArr: pams
      };
    },
    // 弹框全部清除
    cleanAllModel() {
      this.modelList = [];
      this.cleanAll();
      this.modelcheckNum = 0;
    },
    //代理机构 高亮
    highLightByKey(title) {
      let keyword = this.menuForm.searchText;
      if (!title) {
        return title;
      }
      if (!this.agencyShow) {
        return this.replaceColor(title, keyword);
      } else {
        let title1 = this.replaceColor(
          title,
          this.menuForm.agencyTexts[0].name
        );
        let title2 = this.replaceColor(
          title1,
          this.menuForm.agencyTexts[1].name
        );
        let title3 = this.replaceColor(
          title2,
          this.menuForm.agencyTexts[2].name
        );
        return title3;
      }
    },
    replaceColor(title, keyword) {
      if (isEmpty(keyword)) {
        return title;
      }
      if (title.indexOf(keyword) != -1) {
        return title.replace(
          keyword,
          '<font style="color:#FDA14D!important;">' + keyword + "</font>"
        );
      } else {
        return title;
      }
    },
    //重置数据 isAgency代理机构不重置 代理机构特定参数
    resetRes(isAgency, isStatis, isFilterSort) {
      // 结果相关参数
      this.currentPage = 1;
      this.totalCont = 0;
      // this.tableData = [];
      this.lOrS = true;
      if (!isStatis) {
        // 不请求统计就不清除结果
        this.statisticalData = {};
      }

      this.noDataMsg = "欢迎您使用";
      let str = this.getRandomMsg();
      this.randomMsg = str;

      if (!isFilterSort) {
        this.filterJson = {
          agentFilter: [],
          applicantFilter: [],
          classFilter: [],
          classGroupCodeFilter: [],
          codeFilter: [],
          goodsFilter: [],
          groupCodeFilter: [],
          statusFilter: [],
          tradeFlowFilter: [],
          trademarkFilter: []
        };
        this.sortApply = null;
        this.sortRegister = null;
        this.crrOrderName = null;
        this.crrSortName = null;
        this.filterWhere = {
          trademarkName: [],
          classId: [],
          code: [],
          statusId: [],
          proposerInfo: [],
          groupCode: [],
          goods: [],
          allClassGroupCode: [],
          flowName: [],
          agentName: [],
          applyDate: [],
          registerDate: [],
          trademarkIds: [],
          searchAgentId: isAgency ? this.filterWhere.searchAgentId : []
        };
      }
    },
    clickMenuValue(value) {
      this.searchType = value;
      this.resetRes();
      // this.cleanAll(); //清除选中历史
    },
    setKeyCookies() {
      let keyName = "noticeKeyword" + this.searchType;
      var sh = this.$cookies.get(keyName);

      if (this.searchType == "4" && this.applicantShow) {
        for (var i = 0; i < 3; i++) {
          if (this.menuForm.applicantJson.proposer[i].name) {
            sh = this.cookieContrast(
              sh,
              this.menuForm.applicantJson.proposer[i].name
            );
          }
        }
      } else if (this.searchType == "5" && this.agencyShow) {
        for (var i = 0; i < 3; i++) {
          if (this.menuForm.agencyTexts[i].name) {
            sh = this.cookieContrast(sh, this.menuForm.agencyTexts[i].name);
          }
        }
      } else {
        sh = this.cookieContrast(sh, this.menuForm.searchText);
      }

      this.historys[keyName] = sh;
      this.$cookies.set(keyName, sh);
    },
    cookieContrast(sh, value) {
      if (sh) {
        if (sh[0] != value) {
          this.cleanAll(); //清除选中历史
        }
        for (let i = 0, len = sh.length; i < len; i++) {
          value = value.replace(/\s+/g, "");
          if (sh[i] == value) {
            sh.splice(i, 1);
          }
        }
        sh.unshift(value);
        sh = sh.slice(0, 5);
      } else {
        sh = [value];
      }
      return sh;
    },
    /******自定义公告类型******/
    selectCustom() {
      this.isReverse = !this.isReverse;
    },
    optionSelect(item, idx) {
      this.noticeName = item.name;
      this.noticeTypeIndex = idx;
      this.$refs.popoveref.showPopper = false;
      this.isReverse = !this.isReverse;
    }
    /******自定义公告类型 end******/
  }
};
